var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { sessionStorageVersions } from './collection-versions';
import { objectFilter } from './helpers';
var STORAGE_KEY = 'datastore_session_store_v17';
var STORAGE_VERSIONS_KEY = 'datastore_session_store_versions_v1';
export function sessionStorageSyncFactory(performanceTracking) {
    var firstState = true;
    var pendingWrite = false;
    return function (reducer) { return function (state, action) {
        var nextState = state;
        if (firstState) {
            try {
                performanceTracking.mark('read-session-storage-start');
                var sessionStorageState = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
                var cachedSessionStorageVersions_1 = JSON.parse(window.sessionStorage.getItem(STORAGE_VERSIONS_KEY) || '{}');
                performanceTracking.mark('read-session-storage-end');
                performanceTracking.measure('read-session-storage', 'read-session-storage-start', 'read-session-storage-end');
                /*
                 * It is possible that the data saved in session storage is of a
                 * different type than is now expected (as the transformed models have
                 * changed). Rather than doing JSON Schema validation on the saved
                 * storage which would require transmitting a very big JSON file we
                 * hash the schemas and if they don't match we ignore that collection.
                 */
                var validSessionStorageStates = objectFilter(sessionStorageState, function (key, value) {
                    return sessionStorageVersions[key] === cachedSessionStorageVersions_1[key];
                });
                nextState = __assign({}, state, validSessionStorageStates);
            }
            catch (e) {
                // ignore the errors, e.g. quota is full or security error
                console.error(e);
            }
        }
        firstState = false;
        var next = reducer(nextState, action);
        if (!pendingWrite) {
            pendingWrite = true;
            window.requestIdleCallback(function () {
                try {
                    performanceTracking.mark('write-session-storage-start');
                    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
                    window.sessionStorage.setItem(STORAGE_VERSIONS_KEY, JSON.stringify(sessionStorageVersions));
                    performanceTracking.mark('write-session-storage-end');
                    performanceTracking.measure('write-session-storage', 'write-session-storage-start', 'write-session-storage-end');
                }
                catch (e) {
                    // ignore the errors, e.g. quota is full or security error
                    console.error(e);
                }
                pendingWrite = false;
            });
        }
        return next;
    }; };
}
